import React, {Component} from "react"
import styled from "styled-components"
import {Emoji} from "emoji-mart"

import {Para} from "@irati/ui/src/Labels"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import padding from "@irati/ui/src/global/padding"

const Wrapper = styled.div`
  margin-top: ${padding.small};
`

const InlinePara = styled(Para)`
  display: inline;
`

const MaxWidth = styled.div`
  max-width: 350px;
`

const StyledEmoji = styled.span`
  .emoji-mart-emoji {
    margin: 0 5px;
    top: 5px;
  }
`

interface Props {
  onClick: () => void
}

class MakeAClaim extends Component<Props> {
  state = {
    isClicked: false
  }

  handleClick = () => {
    this.setState({isClicked: true})
    this.props.onClick()
  }

  render() {
    const {isClicked} = this.state
    return isClicked ?
      <Wrapper>
        <Card>
          <MaxWidth>
            <InlinePara large light><FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.start" /></InlinePara>
            <StyledEmoji><Emoji emoji={{id: "iphone"}} size={20} set="apple" /></StyledEmoji>
            <InlinePara large blue>
              <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.phoneNumber" />
            </InlinePara>
            <Wrapper>
              <Para>
                <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.para" />
                <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.download" />
              </Para>
            </Wrapper>
          </MaxWidth>
        </Card>
      </Wrapper> :
      <Wrapper>
        <Button primary large full onClick={this.handleClick}>
          <FormattedMessage id="medical.myMedical.accordionItem.makeAClaim.button" />
        </Button>
      </Wrapper>
  }
}

export default MakeAClaim
